import type { GeneratedUserCreative } from "../../../@types/sharedSchema";

export const EDIT_WINDOW_MINUTES = 60;
export const MAX_EDIT_COUNT = 2;
export const EXPIRY_MINUTES_FOR_PENDING = 10;

export function isWithinEditWindow(createdTime: Date): boolean {
  const diffInMinutes = (Date.now() - createdTime.getTime()) / (1000 * 60);
  return diffInMinutes <= EDIT_WINDOW_MINUTES;
}

export function getRemainingEditTimeSeconds(createdTime: Date): number {
  const diffInSeconds = (Date.now() - createdTime.getTime()) / 1000;
  return Math.max(0, EDIT_WINDOW_MINUTES * 60 - diffInSeconds);
}

export function formatTimeRemaining(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
}

export function isExpiredCreative(creative: GeneratedUserCreative): boolean {
  if (creative.status === "completed" || creative.status === "failed") return false;
  if (creative.generatedCreativeUrl) return false;
  if (!creative.createdTime) return false;
  const minutesSinceCreation =
    (Date.now() - creative.createdTime.getTime()) / (1000 * 60);
  return minutesSinceCreation > EXPIRY_MINUTES_FOR_PENDING;
}
